import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../../utils/axiosClient";
import {
  urlAlterar,
  urlInformacoes,
  
  urlApagar,
} from "../../../utils/constants";
import MenuSide from "../../../components/empresas/MenuSide";
import {
  IonButton,
  IonItem,
  IonLabel,
  IonPage,
  IonContent,
  IonInput,
} from "@ionic/react";
import HeaderApp from "../../../components/global/HeaderItem";

export default function EditarDiasExcessaoEmpresas() {
  const navigate = useNavigate();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const idPage = urlParams.get("id");

  const [dia, setDia] = useState("");
  const [horario1, setHorario1] = useState('');
  const [horario2, setHorario2] = useState('');
  const [horario3, setHorario3] = useState('');
  const [horario4, setHorario4] = useState('');

  const consultar = async () => {
    try {
      const url = urlInformacoes("empresas", "dias_excessao", `id=${idPage}`);
      const response = await axiosClient.post(url, {
        
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const atualizar = async () => {
    try {
      const response = await axiosClient.post(urlAlterar("empresas", "dias_excessao"), {
        
        dia: dia,
        horario_inicial_1: horario1,
        horario_final_1: horario2,
        horario_inicial_2: horario3,
        horario_final_2: horario4,
        id: idPage,
      });
      if (response) {
        navigate({ pathname: "/empresas/dias_excessao" });
      }
    } catch (error) {
      return null;
    }
  };

  const apagar = async () => {
    try {
      const response = await axiosClient.post(urlApagar("empresas", "dias_excessao"), {
        
        id: idPage,
      });
      if (response) {
        navigate({ pathname: "/empresas/dias_excessao" });
      }
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const run = async () => {
      let consulta = await consultar();
      setDia(consulta.dia.dia);
      setHorario1(consulta.horarios.horario_inicial_1);
      setHorario2(consulta.horarios.horario_final_1);
      setHorario3(consulta.horarios.horario_inicial_2);
      setHorario4(consulta.horarios.horario_final_2);
    };
    run();
  }, []);

  return (
    <IonPage  id="main-content">
      <HeaderApp />
      <IonContent>
        <div className="ion-margin ion-text-end">
          <IonButton color="danger" onClick={() => apagar()}>
            <i className="ri-delete-bin-line"></i>
          </IonButton>
        </div>
        <IonItem>
          <IonLabel position="stacked">Dia: </IonLabel>
          <IonInput
            type="date"
            placeholder="Dia"
            onIonInput={(event) => {
              event.preventDefault();
              setDia(event.target.value);
            }}
            value={dia}
            disabled={true}
          />
        </IonItem>

        <div className="ion-margin">
          <div className="row">
            <div className="col-12">
              <br />
              <IonLabel className="ion-padding" style={{ fontSize: "12px" }}>
                Horários referentes ao primeiro período do dia.
              </IonLabel>
              <br />
            </div>
            <div className="col-6">
              <IonItem>
                <IonLabel position="stacked">De: </IonLabel>
                <IonInput
                  type="time"
                  onIonChange={(e) => setHorario1(e.detail.value)}
                  value={horario1}
                />
              </IonItem>
            </div>
            <div className="col-6">
              <IonItem>
                <IonLabel position="stacked">Até: </IonLabel>
                <IonInput
                  type="time"
                  onIonChange={(e) => setHorario2(e.detail.value)}
                  value={horario2}
                />
              </IonItem>
            </div>
            <div className="col-12">
              <br />
              <IonLabel className="ion-padding" style={{ fontSize: "12px" }}>
                Horários referentes ao segundo período do dia.
              </IonLabel>
              <br />
            </div>
            <div className="col-6">
              <IonItem>
                <IonLabel position="stacked">De: </IonLabel>
                <IonInput
                  type="time"
                  onIonChange={(e) => setHorario3(e.detail.value)}
                  value={horario3}
                />
              </IonItem>
            </div>
            <div className="col-6">
              <IonItem>
                <IonLabel position="stacked">Até: </IonLabel>
                <IonInput
                  type="time"
                  onIonChange={(e) => setHorario4(e.detail.value)}
                  value={horario4}
                />
              </IonItem>
            </div>
          </div>
        </div>

        <div className="ion-margin">
          <IonButton
            color="secondary-light"
            expand="block"
            onClick={() => atualizar()}
          >
            Atualizar
          </IonButton>
        </div>
      </IonContent>
      <MenuSide />
    </IonPage>
  );
}
